<template>
    <div>        
        <div class="row">   
                         
            <div style="width: 70%;">
                <div class="col-xs-12 col-md-12 offset-md-2 block">
                    <div class="wrapper-progressBar">
                        <ul class="progressBar">
                            <li class="active">Añade Tu Plataforma</li>
                            <li>Añade Tus Canales</li>
                            <li>Selecciona un Video</li>
                            <li>¡Genera Tus Ideas!</li>
                        </ul>
                    </div>
                </div>
            </div>
                    
            <div class="jumbotron bg-light" style="width: 100%; margin-top: 10px;">
                
                <h1 style="margin-top: -40px;" class="display-6" v-if="plataformas_usuario.length <= 0"> <b-skeleton v-if="estado_peticion"></b-skeleton> <p v-else>¡Añade una Plataforma!</p> </h1>
                <h1 style="margin-top: -40px;" class="display-6" v-else>¡Bienvenido!</h1>                
                
                <b-card sub-title="Selecciona una plataforma">
                    <form>
                        <div class="row">
                            <div class="col-sm-8">                     
                                <select v-model="usuarios_plataforma.id_plataforma" class="form-control">
                                    <option :value="plataforma.id" v-for="plataforma in plataformas" v-bind:key="plataforma.id">{{ plataforma.nombre }}</option>
                                </select>
                            </div> 
                            <div class="col-sm-4">
                                                                      
                                    <b-button variant="outline-dark" type="submit" @click.prevent="savePlataformaUsuario"><span class="mdi mdi-plus-circle-outline"></span> Añadir Nueva Plataforma</b-button>                                                                    
                            </div>                            
                        </div>
                    </form>
                </b-card>   
                <p class="lead" v-if="plataformas_usuario.length <= 0">
                    <b-alert show variant="warning"><b-skeleton v-if="estado_peticion"></b-skeleton> <p v-else>Debes crear primero una plataforma para continuar. Esto es necesario porque la plataforma es el entorno principal donde gestionaremos tus canales o posts según tu plataforma.</p> </b-alert>                     
                </p>
                <p v-else style="font-weight: bold;">
                    <b-alert show variant="primary">Por favor selecciona una plataforma para ver tus [Canales/Posts].</b-alert>
                    
                </p>                                             
                <br>              
                <div class="container">
                    <div class="row">

                        <div class="card" v-if="plataformas_usuario.length > 0">
                            <div class="card-body" style="cursor: pointer;" v-for="plataforma in plataformas_usuario" v-bind:key="plataforma" @click="navegacion('canales', plataforma.id_usuario_plataforma)">
                                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/YouTube_full-color_icon_%282017%29.svg/512px-YouTube_full-color_icon_%282017%29.svg.png?20240107144800" alt="Youtube" width="40" height="30"> {{ plataforma.nombre }} 
                            </div>
                        </div>
                        <div class="card" v-else>
                            <div class="card-body">
                                Aún no has agregado una plataforma :(!
                            </div>
                        </div>

                    </div>

                </div>

            </div>  
            
        </div>        
    </div>
</template>
<script>

import {headers} from './../../api/headers'
import {configApi} from './../../api/configApi'

export default {
    name: 'dashboard',
    data: () => ({        
        plataformas_usuario: [],
        plataformas: [],
        estado_peticion: true,
        usuarios_plataforma: {
            id_plataforma: ''
        }
    }),
    mounted() {
        this.getPlataformasUsuario()
        this.getPlataformas()
    },
    methods: {
        async getPlataformasUsuario() {

            return await this.axios.get(configApi+'usuarios_plataforma', {headers})
            .then(response => {
                this.plataformas_usuario = response.data.data;
                this.loading = false 
            })

        },
        async getPlataformas() {

            return await this.axios.get(configApi+'plataforma', {headers})
            .then(response => {
                this.plataformas = response.data.data;
                this.loading = false 
            })

        },
        async savePlataformaUsuario() {
            return await this.axios.post(configApi+'usuarios_plataforma', this.usuarios_plataforma,{headers})
            .then(response => {
                this.$bvModal.hide('crearPlataforma')  
                // this.resetForm()                 
                this.getPlataformasUsuario()      
                this.usuarios_plataforma.id_plataforma = ''          

                if(response.data.data.id > 0) {
                    this.$Fun.alertaAccion('success', response.data.message, false)
                } else {
                    this.$Fun.alertaAccion('warning', response.data.message, false)
                }

            })
        },
        navegacion(menu, id_usuplataforma) {
            this.$router.push('/'+menu)
            localStorage.setItem('id_usuario_plataforma', id_usuplataforma)
        },
    }
}
</script>